var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatPreguntasA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.26,
    height: 18.955,
    viewBox: "0 0 17.26 18.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-430.414 -602.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346 200.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.023,46.666h-6.782A4.244,4.244,0,0,0,140,50.9V62.773a.848.848,0,0,0,1.447.6L142.5,62.32a4.212,4.212,0,0,1,3-1.242h5.523a4.244,4.244,0,0,0,4.239-4.239V50.9a4.244,4.244,0,0,0-4.239-4.239Z",
    transform: "translate(-54.588 356.395)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.541,124.9a.909.909,0,0,1-.6-.219.688.688,0,0,1,0-1.059.93.93,0,0,1,1.2,0,.688.688,0,0,1,0,1.059A.908.908,0,0,1,282.541,124.9Zm1.5-4.176a1.265,1.265,0,0,0-.655.986v.2a.737.737,0,0,1-.424.648.946.946,0,0,1-.848,0,.737.737,0,0,1-.424-.648v-.2a2.673,2.673,0,0,1,1.349-2.193.717.717,0,0,0,.344-.665.754.754,0,0,0-.462-.607.946.946,0,0,0-.827.03.734.734,0,0,0-.4.638.737.737,0,0,1-.424.648.946.946,0,0,1-.848,0,.737.737,0,0,1-.424-.648,2.2,2.2,0,0,1,1.212-1.913,2.838,2.838,0,0,1,2.481-.089,2.259,2.259,0,0,1,1.385,1.82,2.15,2.15,0,0,1-1.032,1.994Z",
    transform: "translate(-189.498 289.592)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatPreguntasA);
export default __webpack_public_path__ + "static/media/LAT-PREGUNTAS-A.3a995c9af209a958b951f966b4d73ed5.svg";
export { ForwardRef as ReactComponent };